import React from 'react';
import './style.css';
import TabTwo from '../tab/TabTwo';

function OurTechnologies() {
  const sliderImages = [
    '/images/CustomImages/OurTechnologies/1.svg',
    '/images/CustomImages/OurTechnologies/2.svg',
    '/images/CustomImages/OurTechnologies/3.svg',
    '/images/CustomImages/OurTechnologies/4.svg',
    '/images/CustomImages/OurTechnologies/5.svg',
    '/images/CustomImages/OurTechnologies/6.svg',
    '/images/CustomImages/OurTechnologies/7.svg',
    '/images/CustomImages/OurTechnologies/8.svg',
    '/images/CustomImages/OurTechnologies/9.svg',
    '/images/CustomImages/OurTechnologies/10.svg',
    '/images/CustomImages/OurTechnologies/11.svg',
    '/images/CustomImages/OurTechnologies/12.svg',
  ];

  const repeatedImages = [...sliderImages, ...sliderImages, ...sliderImages, ...sliderImages, , ...sliderImages, ...sliderImages];

  return (
    <div id='OurTechnologies_no-bootstrap-zone'>
      <h3>Our Technologies</h3>
      <div className='OurTechnologies_slider_container'>
        <div className='OurTechnologies_slider'>
          {repeatedImages.map((item, i) => (
            <img key={i} src={item} className='OurTechnologies_slide' loading='lazy' />
          ))}
        </div>
      </div>
      <div className='OurTechnologies_tabs_container'>
        <div className="rwt-tab-area" style={{ paddingTop: '6rem', paddingBottom: '6rem', }}>
          <TabTwo />
        </div>
      </div>
    </div>
  );
}

export default OurTechnologies;
